module.exports = "<div>\r\n    <p><span [innerHtml]=\"orderInteraction.Prompt\"></span></p>\r\n    <ul id=\"order-interaction-{{interaction.InteractionId}}\" class=\"order-interaction\">\r\n        <li *ngFor=\"let choice of choices\" data-id=\"{{choice.Identifier}}\">\r\n            <span [innerHtml]=\"choice.Html\"></span>\r\n        </li>\r\n    </ul>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// C:/_/Platform1/Paragon/Application/Common/UI.RenderEngine/src/app/components/pg-renderer/item-body/item-body-panel/interaction/order-interaction/order-interaction.html
// module id = sVWc
// module chunks = 1